import React, { useEffect, useState } from "react";
import { Button, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import { useHistory, useLocation } from "react-router-dom";

export default function PostLoginFileNoticeSnackbars() {
  const history = useHistory();
  const location = useLocation();
  const [lastFileNotice, setLastFileNotice] = useState(
    () => location.state?.postLoginFileNotice ?? null
  );

  useEffect(() => {
    if (!location.state?.postLoginFileNotice) {
      return;
    }
    history.replace({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    });
  }, [history, location.pathname, location.search, location.hash]);

  function closeLastFileNotice() {
    setLastFileNotice(null);
  }

  function goToFailedFile() {
    if (lastFileNotice?.fileId != null) {
      history.push(`/upload?fileId=${encodeURIComponent(lastFileNotice.fileId)}`);
    } else {
      history.push("/upload");
    }
    closeLastFileNotice();
  }

  function getErrorMessage(lastFileNotice) {
    if (!lastFileNotice) {
      return "";
    }
    const type = lastFileNotice.type;
    const errorCount = Number(lastFileNotice.errorCount) || 0;
    const summary = lastFileNotice.summary;

    const isFailed =
      type === "FAILED" ||
      type === "FAILED_SCORING" ||
      type === "SCORING_FAILED";

    const invalidSchemaMessage =
      "Your last upload failed due to column/s missing in the file. Reupload the correct notification register.";
    const ErrorMapping = {
      "Invalid Schema": invalidSchemaMessage,
      "Invailid Schema": invalidSchemaMessage,
      Other:
        "Your last upload failed due to technical issue. Please reach out to the Wadhwani AI Team",
    };

    if (isFailed) {
      const key = typeof summary === "string" ? summary.trim() : summary;
      return ErrorMapping[key] ?? ErrorMapping.Other;
    }

    if (type === "SCORED") {
      if (errorCount > 0) {
        return `Your last upload is complete but contains ${errorCount} errors. Re-upload the notification register for error cases.`;
      }
      return "Your last upload is complete. You can view the results on the Adverse Outcomes page.";
    }

    return "";
  }


  return (
    <>
      <Snackbar
        open={lastFileNotice?.type === "SCORED"}
        autoHideDuration={6000}
        onClose={closeLastFileNotice}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert onClose={closeLastFileNotice} severity={lastFileNotice?.errorCount > 0 ? "error" : "success"} variant='filled'>
          {getErrorMessage(lastFileNotice)}
        </MuiAlert>
      </Snackbar>
      <Snackbar
        open={
          lastFileNotice?.type === "FAILED" ||
          lastFileNotice?.type === "FAILED_SCORING" ||
          lastFileNotice?.type === "SCORING_FAILED"
        }
        autoHideDuration={null}
        onClose={closeLastFileNotice}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          onClose={closeLastFileNotice}
          severity="error"
          variant="filled"
          action={
            <Button color="inherit" size="small" onClick={goToFailedFile}>
              View file
            </Button>
          }
        >
          {getErrorMessage(lastFileNotice)}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
